export default {
    lotteryQr: 'Qr code de loterie  ',
    checkResult: ' Contrôler résultat doit ',
    downloadApp: ' Télécharger APP',
    prize: ' Prix',
    introTitle: 'How to conduct a lottery and claim prizes',
    lotteryRule: ' Règles de loterie',
    checkDetailsHint: '（Cliquez pour voir les détails）',
    addCardHint1: 'Ajoutez votre',
    addCardHint2: 'carte à Laidan',
    howGetCard: 'Comment obtenir votre carte',
    getCardText: 'Vous pouvez obtenir votre carte via l\'application mobile gratuite Laidan',
    flowTitle1: 'Téléchargez Laidan',
    flowText1: "Si vous n'avez pas Laidan, vous pouvez l'utiliser pour alléger votre portefeuille",
    flowTitle2: 'Ajoutez votre carte',
    flowText2: 'Une fois que vous avez installé Laidan, appuyez sur ce bouton pour ajouter la carte à l\'application !',
    flowTitle3: 'Terminé !',
    flowText3: 'Profitez de votre expérience d\'achat mobile améliorée !',
    flowBtnText1: 'Obtenir',
    flowBtnText2: 'Télécharger depuis',
    flowBtnText3: 'Ajouter à',
    merchantOs: 'Votre propre système marchand',
    howCreateOs: 'Comment créer votre système',
    createOsText: "Vous pouvez gérer vos produits et créer un système de membres avec l'application mobile gratuite Joinku",
    kuTitle1: 'Téléchargez Joinku',
    kuText1: "Si vous n'avez pas Joinku, vous pouvez l'utiliser pour gagner du temps précieux !",
    kuTitle2: 'Consultez votre système',
    kuText2: "Une fois que vous avez installé Joinku, appuyez sur ce bouton pour consulter les membres et les commandes !",
    kuTitle3: 'Terminé !',
    kuText3: 'Profitez de votre expérience de gestion de système améliorée !',
    taxExpert: 'Votre expert en facturation électronique',
    howGetTax: 'Comment obtenir votre facture électronique',
    getTaxText: 'Vous pouvez recevoir votre facture électronique et participer à des tirages au sort de commerçants via l\'application mobile gratuite Laidan',
    danTitle1: 'Téléchargez Laidan',
    danText1: "Si vous n'avez pas Laidan, vous pouvez l'utiliser pour profiter de plus d'offres !",
    danTitle2: 'Consultez vos offres',
    danText2: "Une fois que vous avez installé Laidan, appuyez sur ce bouton pour profiter de vos offres !",
    danText3: 'Profitez de votre expérience mobile d\'offres améliorée !',
    inviteCashDedu: 'Réduction en espèces par invitation',
    inviteCode: 'Code d\'invitation',
    copyInviteCode: 'Cliquez pour copier le code d\'invitation !',
    copySucceed: 'Copié avec succès !',
    copyError: 'Échec de la copie !',
    memberSystem: 'Système de membres',
    memberSystemText: "Pour chaque nouvel utilisateur invité à s'inscrire sur Joinku en utilisant votre code d'invitation, vous recevrez une réduction de 100€ sur les frais annuels",
    inviteTitle2: 'Configurer le code d\'invitation',
    inviteText2: "Une fois que vous avez installé Joinku, copiez d'abord le code d'invitation, puis appuyez sur ce bouton pour accéder à Joinku !",
    inviteText3: 'Obtenez une réduction en espèces sur les frais annuels !',
    flowBtnText4: 'Découvrir',
    phoneLabel: 'Téléphone:',
    addressLabel: 'adresse:',
    readAndAccept: 'lire et accepter',
    privacyPolicy: 'politique de confidentialité',
    startLottery: 'commencer la loterie',
    usePhoneLogin: 'Connectez-vous avec un numéro de téléphone portable',
    useEmailLogin: 'Connectez-vous par e-mail',
    phoneLogin: 'Connexion au numéro de téléphone mobile',
    countryCodeSearch: 'Entrez le nom du pays, l\'indicatif régional pour rechercher',
    emailLogin: 'Connexion par e-mail',
    getAuthCode: 'obtenir le code de vérification',
    inpPhoneHint: 'Veuillez entrer le numéro de téléphone',
    inpEmailHint: 'Veuillez entrer votre compte e-mail',
    inpAuthCode: 'veuillez entrer le code de vérification',
    codeVerifyTitle: 'Veuillez compléter le contrôle de sécurité',
    codeVerifyHint: 'Balayez vers la droite pour terminer la vérification',
    verifyError: 'Validation échouée',
    verifyFinish: 'vérification terminée',
    login: 'Connexion',
    clickCheck: 'cliquez pour voir',
    downAppPrize: 'Téléchargez l\'APP pour voir les prix',
    lottoErrorHint: 'Mauvais code de loterie',
    lottoNoloHint: 'Veuillez patienter',
    lottoNowiHint: 'désolé de ne pas gagner',
    lottoWinnHint: 'Félicitations pour avoir gagné le prix !!!',
    lottoUsedHint: 'Ce code de loterie a déjà été utilisé',
    partPlatLotto: 'Bienvenue pour participer à la loterie de la plateforme',
    skipPlatLotto: 'Passez ensuite automatiquement à la page de loterie de la plate-forme',
    skipPrize: 'Accéder automatiquement à la page des prix',
    allowMerRead: 'Autoriser les commerçants à accéder à mes informations:',
    infoMore: 'nom, numéro de téléphone, anniversaire',
    joinMember: 'rejoindre un membre',
    checkMember: 'voir les membres',
    drawPlatCoupon: 'Recevez des coupons de plateforme',
    moreDisDis: 'Plus de réductions',
    firLoginDraw: 'La première fois que vous vous connectez à l\'APP, vous pouvez obtenir',
    clickDown: 'Cliquez pour télécharger',
    appDraw: 'l\'APP pour recevoir',
    validTime: 'Valable jusque',
    useAwaCodeHint: 'Veuillez l\'utiliser lors de votre prochain repas et présenter le code-barres à la caisse',
    platLottoCode: 'Code de loterie de la plate-forme',
    lottoCode: 'Code tirage au sort:',
    lotteryTime: 'Temps de tirage: ',
    noLottery: 'Non dessiné',
    yetWinning: 'A gagné',
    noWinning: 'N\'a pas gagné',
    haveUsed: 'Utilisé',
    sellOut: 'Épuisé',
    currentPrice: 'Définir date/heure',
    includeAllergen: 'Comprend les allergènes',
    details: 'Les ordres détaillés',
    selectAllergen: 'Les ordres en cours',
    rawMaterials: 'Les ingrédients:',
    cookingWay: 'Méthode de cuisson:',
    allergens: 'Contenant les allergènes:',
    mayAddMaterials: 'Ingrédients ajoutables:',
    mayMinusMaterials: 'Ingrédients jetables:',
    taste: 'Préférence de goût:',
    selectedGroupNum: 'Quantité de plaque sélectionnée:',
    priceZero: 'plats au prix 0',
    priceNoZero: 'Plats avec un prix différent de 0',
    notSetMealDishes: 'Il n\'y a pas de vaisselle dans cet ensemble',
    notGroupDishes: 'Il n\'y a pas de plats dans cette catégorie',
    notDishesMat: 'Il n\'y a pas de matières premières dans ce plat',
    notGroupMat: 'Il n\'y a pas de matières premières dans cette catégorie',
    selectFinish: 'Choisi',
    noSelectFinish: 'Pour sélectionner',
    cancel: 'Annuler',
    woka: {
        activityPage: 'Page de l\'événement',
        unlockDish: 'Débloquer des plats gratuitement',
        unlockText: 'Participez à l\'événement de partage selon les règles pour débloquer gratuitement un plat au choix !',
        activityRule: 'Règles de l\'événement',
        ruleText: 'Choisissez l\'une des méthodes suivantes, téléchargez une capture d\'écran à l\'emplacement désigné et recevez un code de plat.',
        issueWork: 'Publier du contenu',
        weChat: 'WeChat',
        wechatText: 'Partagez sur votre profil et recueillez 20 "J\'aime" de vos amis.',
        douyinText1: '1. Participez au sujet #AssistantCuisineAI#',
        douyinText2: '2. Commentaire épinglé',
        douyinText3: '3. Publiez sur TikTok @xxxx',
        redBook: 'Xiaohongshu',
        redBookText2: '2. Marquez votre position',
        instagramText1: '1. Publiez une story + publication/Reels publics',
        instagramText2: '2. @Mentionnez 3 amis',
        tikTokText1: '1. Story temporaire',
        tikTokText2: '2. Oeuvre publique @mentionnez 3 amis',
        partActivity: 'Participez à l\'événement',
    }
};
